import { HighlightOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationFailed } from './interfaces';

interface Props {
  operation: OperationFailed;
}

const FailureOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { cost, recipientMsisdn, operator, details } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            {
              label: locales.operation.label.recipient,
              value: detailsValueFormatter(recipientMsisdn)
            },
            { label: locales.operation.label.operatorName, value: operator },
            { label: locales.operation.label.smsSenderName, value: detailsValueFormatter(details.senderName) },
            {
              label: locales.operation.label.smsExternalProvider,
              value: detailsValueFormatter(details.externalProvider)
            },
            { label: locales.operation.label.smsExternalId, value: detailsValueFormatter(details.externalId) },
            { label: locales.operation.label.smsMessageContent, value: detailsValueFormatter(details.messageContent) },
            {
              label: locales.operation.label.smsErrorDescription,
              value: detailsValueFormatter(details.errorDescription)
            }
          ]}
        />
      }
    />
  );
};

export default FailureOperation;
